import {Tag, Tooltip} from 'antd';

// Provider-side state of a withdrawal, kept apart from the Daba `status`. Only
// providers whose automata stamps it report one (Maviance today); for every
// other provider the backend returns null and the cell shows a dash rather
// than guessing.
export const PROVIDER_STATUS_OPTIONS = [
  {value: 'NOT_SENT', label: 'Not sent to provider', color: 'default'},
  {value: 'SUBMITTED', label: 'Submitted to provider', color: 'blue'},
  {value: 'SUBMISSION_FAILED', label: 'Submission failed', color: 'volcano'},
  {value: 'SUCCESSFUL', label: 'Provider successful', color: 'green'},
  {value: 'FAILED', label: 'Provider failed', color: 'red'},
];

export const providerStatusLabel = value =>
  PROVIDER_STATUS_OPTIONS.find(option => option.value === value)?.label ??
  value;

export const ProviderStatusTag = ({status, transferId}) => {
  if (!status) return <span>—</span>;
  const option = PROVIDER_STATUS_OPTIONS.find(o => o.value === status);
  const tag = <Tag color={option?.color || 'blue'}>{status}</Tag>;
  if (!transferId) return tag;
  return (
    <Tooltip trigger="hover" title={`Provider ref: ${transferId}`}>
      {tag}
    </Tooltip>
  );
};
